<template>
	<dl class="--input-group">
		<dt>{{ label }}</dt>
		<dd :class="{ '--fit': fit }">
			<slot />
		</dd>
	</dl>
</template>

<script>
export default {
	name: 'FormGroup',
	props: {
		label: {
			type: String,
			required: true
		},
		fit: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.--input-group {
	display: flex;
	margin: .5em 0;
	line-height: 1.5;

	&,
	& * {
		box-sizing: border-box;
	}

	> dt {
		width: 8em;
		margin: 0;
		padding: 0.1875rem 1.25em 0 0;
		font-size: 87.5%;
		font-weight: 700;
		text-align: right;
	}

	> dd {
		flex: 1;
		margin: 0;
		padding: 0;
	}

	.--fit {
		display: flex;
		align-items: center;

		> input,
		.--space {
			flex: 1;
		}

		.--dash-range {
			margin: 0 .1em;
		}

		.--unit {
			margin: 0 0 0 .2em;
		}
	}

	.--note {
		display: block;
		margin: 0;
		font-size: 75%;
		opacity: .66;
	}
}
</style>
